import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    dashboardWrapper: {
        height: 1,
        width: 1,
        overflow: 'hidden',
    },
};
